export const REQUEST_EDIT_CATEGORY_FORM_CATEGORY_FIELD = 'category'

export const REQUEST_EDIT_CATEGORY_FORM_INITIAL_VALUES = {
  [REQUEST_EDIT_CATEGORY_FORM_CATEGORY_FIELD]: null,
}

export const QA_NAME_REQUEST_EDIT_CATEGORY_FORM_MODAL = 'editCategory'
